import { render, staticRenderFns } from "./singleElectionac.vue?vue&type=template&id=606056cc&scoped=true&lang=html&"
import script from "./singleElectionac.vue?vue&type=script&lang=js&"
export * from "./singleElectionac.vue?vue&type=script&lang=js&"
import style0 from "./singleElectionac.vue?vue&type=style&index=0&id=606056cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606056cc",
  null
  
)

export default component.exports